import { useTheme } from "@emotion/react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import Page from "components/Page";
import { useRecoilValue } from "recoil";
import { instanceIdAtom } from "lib/globalState";
import { useEffect } from "react";
import { currentAppAtom } from "../lib/globalState";
import { useObjectVal } from "react-firebase-hooks/database";
import { fireRDB } from "../lib/firebase";

//controllare refresh
import pepperDorme from "assets/images/pepperdorme.png";

const PepperOffline = () => {
	const theme = useTheme();
	const instanceId = useRecoilValue(instanceIdAtom);
	const appId = useRecoilValue(currentAppAtom);
	const [snapshot, loading, error] = useObjectVal(fireRDB.ref(`/robots/${instanceId}/online`));

	const onEnd = () => {
		setTimeout(() => {
			window.location = "/scansiona";
		}, 10 * 1000);
	};

	useEffect(() => {
		if (snapshot === false) {
			console.log("robot offline");
		} else if (snapshot === true) {
			console.log("robot online");
			onEnd();
		}
	}, [snapshot]);

	return (
		<Page bg={theme.palette.background.paper}>
			<Box sx={{
				minHeight: "100%",
				flex: 1,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center"
			}}>
				<img src={pepperDorme} alt="pepper dorme" style={{marginLeft: "-5%"}}/>
				<Typography variant="h5" color={theme.palette.text.primary} sx={{
					paddingInline: "2rem",
					textAlign: "center"
				}}>
					Pepper si sta riposando.
				</Typography>
				<Typography variant="h5" color={theme.palette.text.primary} sx={{
					paddingInline: "2rem",
					textAlign: "center"
				}}>
					Torna un’altra volta per
					provare l’esperienza!
				</Typography>
			</Box>
		</Page>
	);
};

export default PepperOffline;